import { registerRootComponent } from 'expo';
import { Platform } from 'react-native';

import App from './App';
import { captureException, hasTelemetryProvider } from './src/services/telemetry';
import { initTelemetry } from './src/services/telemetrySentry';

// Inicializa o provider de telemetria (Sentry) antes de qualquer coisa, para que
// o handler global abaixo e todo captureException do app já tenham para onde
// reportar. No-op sem DSN ou em DEV (ver telemetrySentry.js).
initTelemetry();

// Handler global de último recurso: captura erros JS que escapam da árvore
// React (timers, listeners de evento, rejeições em libs nativas) e que,
// portanto, NÃO são vistos por nenhum ErrorBoundary. Encadeia o handler
// default do RN para preservar o comportamento de crash em erros fatais.
if (typeof ErrorUtils !== 'undefined' && ErrorUtils.setGlobalHandler) {
    const previousHandler = ErrorUtils.getGlobalHandler?.();
    ErrorUtils.setGlobalHandler((error, isFatal) => {
        captureException(error, { source: 'globalHandler', fatal: !!isFatal });
        previousHandler?.(error, isFatal);
    });
}

// WEB: handlers globais PROVISÓRIOS.
//
// Na web o SDK de telemetria é carregado em chunk separado, depois do boot (ver
// `telemetrySentry.js`) — então os handlers globais do próprio Sentry só passam a
// existir quando o chunk chega. Sem estes dois listeners, um erro nesse intervalo
// não seria visto por ninguém. `unhandledrejection`, aliás, o `ErrorUtils` acima
// não cobre em plataforma nenhuma.
//
// O facade enfileira o que chegar antes do provider e reenvia quando ele existe.
// Assim que há provider, paramos de encaminhar: o Sentry instala os próprios
// handlers e encaminhar aqui também reportaria o mesmo erro duas vezes.
if (Platform.OS === 'web' && typeof window !== 'undefined') {
    window.addEventListener('error', (event) => {
        if (hasTelemetryProvider()) return;
        captureException(event?.error || event?.message || 'window.onerror', {
            source: 'window.onerror',
            preProvider: true,
        });
    });
    window.addEventListener('unhandledrejection', (event) => {
        if (hasTelemetryProvider()) return;
        captureException(event?.reason || 'unhandledrejection', {
            source: 'unhandledrejection',
            preProvider: true,
        });
    });
}

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
